import type { ListType } from '@/models/app';
import { FamilyRelationship } from '@/models/lovedOne';

export const familyRelationList: ListType[] = [
  { id: 1, key: FamilyRelationship.Assistant, label: 'Assistant' },
  { id: 2, key: FamilyRelationship.Brother, label: 'Brother' },
  { id: 3, key: FamilyRelationship.BrotherInLaw, label: 'Brother-In-Law' },
  { id: 4, key: FamilyRelationship.Caregiver, label: 'Caregiver' },
  { id: 5, key: FamilyRelationship.Daughter, label: 'Daughter' },
  { id: 7, key: FamilyRelationship.Father, label: 'Father' },
  { id: 6, key: FamilyRelationship.FatherInLaw, label: 'Father-In-Law' },
  { id: 7, key: FamilyRelationship.Friend, label: 'Friend' },
  { id: 8, key: FamilyRelationship.Granddaughter, label: 'Granddaughter' },
  { id: 9, key: FamilyRelationship.Grandfather, label: 'Grandfather' },
  { id: 10, key: FamilyRelationship.Grandmother, label: 'Grandmother' },
  { id: 11, key: FamilyRelationship.Grandson, label: 'Grandson' },
  { id: 12, key: FamilyRelationship.Husband, label: 'Husband' },
  { id: 13, key: FamilyRelationship.Mother, label: 'Mother' },
  { id: 14, key: FamilyRelationship.MotherInLaw, label: 'Mother-In-Law' },
  { id: 15, key: FamilyRelationship.Nephew, label: 'Nephew' },
  { id: 16, key: FamilyRelationship.Niece, label: 'Niece' },
  { id: 17, key: FamilyRelationship.NurseCaretaker, label: 'Nurse / Caretaker' },
  { id: 18, key: FamilyRelationship.Other, label: 'Other' },
  { id: 19, key: FamilyRelationship.Partner, label: 'Partner' },
  { id: 20, key: FamilyRelationship.Pastor, label: 'Pastor' },
  { id: 21, key: FamilyRelationship.Sister, label: 'Sister' },
  { id: 22, key: FamilyRelationship.SisterInLaw, label: 'Sister-In-Law' },
  { id: 23, key: FamilyRelationship.Son, label: 'Son' },
  { id: 24, key: FamilyRelationship.Wife, label: 'Wife' },
];
